import { useEffect, useState } from "react";

import NitroModal from "../../components/Modal";
import ZIndex from "../../styles/zindex";

import Guidance from "./tabs/guidance";
import GuidanceHistory from "./tabs/guidanceHistory";

import "./index.css";
import { useNitroStore } from "../../store/Store";

const GuidancePanel = ({
  initalProduct,
  open,
  onSave,
  close,
}: {
  initalProduct?: string;
  open: boolean;
  onSave?: () => void;
  close: () => void;
}) => {
  const [editing, setEditing] = useState(false);

  const [
    location,
    setLocation,
    searchStarted,
  ] = useNitroStore((state) => [
    state.guidanceLocation,
    state.setGuidanceLocation,
    state.searchStarted,
  ]);

  const [selectedMonth, setSelectedMonth] = useState<string | null>(null);
  const [product, setProduct] = useState<string>(initalProduct || "");
  useEffect(() => {
    setProduct(initalProduct || "");
  }, [initalProduct]);

  return (
    <>
      {open && (
        <div
          id="opaque-background"
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: ZIndex.OpaqueBackground,
            backgroundColor: "rgba(15, 44, 82, 0.3)", // Selecting pin location
          }}
        />
      )}

      <NitroModal
        id="guidance-panel"
        open={open}
        className={` ${searchStarted ? "guidancePanel" : "guidancePanelLeft"} `}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            flexGrow: 1,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            zIndex: 102,
          }}
        >
          {selectedMonth && (
            <GuidanceHistory
              location={location}
              product={product}
              date={selectedMonth}
              close={() => {
                setSelectedMonth("");
              }}
            />
          )}

          {!selectedMonth && (
            <Guidance
              location={location}
              setLocation={setLocation}
              // mode={mode}
              product={product}
              setProduct={setProduct}
              editing={editing}
              setEditing={setEditing}
              setSelectedMonth={setSelectedMonth}
              onSave={onSave}
              close={close}
            />
          )}
        </div>
      </NitroModal>
    </>
  );
};

export default GuidancePanel;
